module.exports = __webpack_public_path__ + "static/media/06PerformancePhotos.4996069c.jpeg";